var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{class:['footer', _vm.themeCssClass]},[_c('div',{staticClass:"footer-line"},[_vm._v("\n\t\t© "+_vm._s(_vm.year)+" "+_vm._s(_vm.legalCompanyName)+" | All Rights Reserved\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }